export const SEARCH_HELPER = [
  ["code", "ID"],
  ["organisation.physical_state", "State"],
  ["organisation.business_name", "Claim Payee Organisation"],
  ["invoice.code", "Invoice"],
  ["grouped", "Grouped"]
];
